// Import model
import { StartEstimateRemoveItemRequest } from '../models/StartEstimateRemoveItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateRemoveItemRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateRemoveItemRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateRemoveItemRequest instance
   */
  static deserialize(json: string): StartEstimateRemoveItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateRemoveItemRequest instance
   */
  static fromObject(obj: any): StartEstimateRemoveItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateRemoveItemRequest');
    }


    const instance: StartEstimateRemoveItemRequest = {
      source: obj['source'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateRemoveItemRequest instances
   */
  static deserializeArray(json: string): StartEstimateRemoveItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateRemoveItemRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateRemoveItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateRemoveItemRequest instance to a plain object
   */
  static toObject(instance: StartEstimateRemoveItemRequest): any {
    return {
      'source': instance.source,
      'itemId': instance.itemId,
    };
  }

  /**
   * Serializes an array of StartEstimateRemoveItemRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateRemoveItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
